<template>
    <div ref="$page" class="elle-page">
        <TemplatesPage v-if="status == 'success'" :data="pageData" />
    </div>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

definePageMeta({
    pageTransition: usePageTransition()
});

const route = useRoute();
const router = useRouter();
const dataLenis = useLenisData();
const $page = ref<HTMLElement | null>(null);
const setI18nParams = useSetI18nParams();

const { data: page, status } = await useAsyncGql({
    operation: 'page',
    variables: {
        siteId: useSiteId(),
        slug: route.params?.slug
    }
});

const pageData = computed<CmsItem>(() => (page.value?.page as CmsItem) ?? {});

if (page.value?.page) {
    route.meta.nuxtI18n = useLocalizedSlug(pageData.value);
    setI18nParams(useLocalizedSlug(pageData.value));
    usePageSettings(pageData.value.typeHandle, pageData.value.sectionHandle);
    useSeoData(pageData.value.seo);
} else {
    throw createError({ statusCode: 404, statusMessage: 'Page Not Found' });
}

useStartAnimations($page.value, () => {
    setTimeout(() => {
        if (route.hash) {
            const goTo = route.hash;
            const el = document.getElementById(goTo.substring(1));

            if (el && dataLenis.value) {
                dataLenis.value.scrollTo(el, {
                    duration: 2,
                    offset: -100
                });
            }

            nextTick(() => {
                router.replace({
                    path: route.path,
                    query: route.query
                });
            });
        }
    }, 150);
});
</script>
